import {
  // isEmpty,
  findIndex
} from "lodash";
import update from "immutability-helper";
import moment from "moment";

export const messagingProps = {
  loadedMessages: false,
  readMessages: moment().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
};

export const messageDrawerReducerDefaultState = {
  open: false,
  activeChatter: "",
  activeChats: [],
  visible: true
};

export default (state = messageDrawerReducerDefaultState, action) => {
  switch (action.type) {
    case "MESSAGE_DRAWER::TOGGLE":
      return {
        ...state,
        open: action.open
      };
    case "MESSAGE_DRAWER::ACTIVE_CHATTER::SET":
      const existingChatter = state.activeChats.find(
        c => c.id === action.activeChatter.id
      );
      let updates = {};
      if (!existingChatter) {
        updates = {
          activeChats: {
            $push: [
              {
                ...action.activeChatter,
                messages: [],
                ...messagingProps
              }
            ]
          }
        };
      }
      return update(state, {
        activeChatter: {
          $set: action.activeChatter.id
        },
        ...updates
      });
    case "MESSAGE_DRAWER::ACTIVE_CHATTER::SET_READ":
      return {
        ...state,
        activeChats: state.activeChats.map(c => {
          if (c.id === action.userId) {
            c = {
              ...c,
              readMessages: moment().format(
                moment.HTML5_FMT.DATETIME_LOCAL_SECONDS
              )
            };
          }
          return c;
        })
      };
    case "MESSAGE_DRAWER::ACTIVE_CHATTER::REMOVE":
      const currentIndex = findIndex(state.activeChats, {
        id: action.userId
      });
      const getNextChatter = () => {
        if (state.activeChatter === action.userId) {
          if (currentIndex === 0) {
            return state.activeChats[1].id;
          } else {
            return state.activeChats[currentIndex - 1].id;
          }
        } else {
          return state.activeChatter;
        }
      };
      return {
        ...state,
        activeChats: state.activeChats.filter(c => c.id !== action.userId),
        activeChatter: state.activeChats.length > 1 ? getNextChatter() : ""
      };
    case "MESSAGE_DRAWER::MESSAGES::SET":
      return {
        ...state,
        activeChats: state.activeChats.map(c => {
          if (c.id === action.userId) {
            c.messages = action.messages;
            c.loadedMessages = true;
            c.readMessages = moment().format(
              moment.HTML5_FMT.DATETIME_LOCAL_SECONDS
            );
          }
          return c;
        })
      };
    case "MESSAGE_DRAWER::MESSAGES::SET_LOADING":
      return {
        ...state,
        activeChats: state.activeChats.map(c => {
          if (c.id === action.userId) {
            if (c.messages.length === 0) {
              c.messages = ["LOADING"];
            }
          }
          return c;
        })
      };
    case "MESSAGE_DRAWER::MESSAGES::PUSH":
      return {
        ...state,
        activeChats: state.activeChats.map(c => {
          if (c.id === action.userId) {
            c.messages = [...c.messages, action.message];
          }
          return c;
        })
      };
    case "MESSAGE_DRAWER::VISIBILITY::SET":
      return {
        ...state,
        visible: action.visible
      };
    case "MESSAGE_DRAWER::ACTIVE_CHATTER::RATING::SET":
      return {
        ...state,
        activeChats: state.activeChats.map(c => {
          if (c.id === action.userId) {
            if (action.rating.hasOwnProperty("id")) {
              c.ratings = c.ratings.map(r => {
                if (r.id === action.rating.id) {
                  const newId = action.rating.newId;
                  delete action.rating.newId;
                  r = {
                    ...r,
                    ...action.rating,
                    id: newId
                  };
                }
                return r;
              });
            } else {
              c.ratings = [...c.ratings, ...action.rating];
            }
            c.avg_rating = action.avgRating;
          }
          return c;
        })
      };
    case "MESSAGE_DRAWER::CLEAR":
      return {
        ...state,
        activeChatter: "",
        activeChats: []
      };
    default:
      return state;
  }
};
